// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".event-page[data-v-412016ae]  .event-additional{margin-top:72px;margin-bottom:72px}.event-page[data-v-412016ae]  .event-recommendations,.event-page[data-v-412016ae]  .event-schedule{margin-top:72px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
